(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jw-help-contact"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){if(e.target.closest('[data-open-notices]')){const n=document.getElementById('jw-help-notices');if(n)n.open=true}});

  } catch(e) { console.error(e); }
})();
})();
